import { runtimeConfig } from '@primerai/ui-tools';

declare global {
  interface Window {
    env: Record<symbol | string, string>;
  }
}

type Config = Record<symbol | string, string>;

const windowIsDefined = typeof window !== 'undefined';
const windowEnvExists = windowIsDefined && typeof window.env !== 'undefined';

const config: Config = windowEnvExists
  ? window.env
  : {
      ...runtimeConfig, // this will pull in all VITE_ prefixed env variables
      CUSTOMER_SERVICE_PROVIDER: process.env.CUSTOMER_SERVICE_PROVIDER ?? '',
      ENABLE_TRACKING: process.env.ENABLE_TRACKING ?? '',
      HELP_URL: process.env.HELP_URL ?? '',
      LOG_REDUX_ACTIONS: process.env.LOG_REDUX_ACTIONS ?? '',
      LOGIN_WARNING_ID: process.env.LOGIN_WARNING_ID ?? '',
      PRIMER_ANALYZE_URL: process.env.PRIMER_ANALYZE_URL ?? '',
      REDIRECT_WHITELISTED_DOMAINS:
        process.env.REDIRECT_WHITELISTED_DOMAINS ?? '',
      SEGMENT_WRITE_KEY: process.env.SEGMENT_WRITE_KEY ?? '',
      SINGLE_IDP_URL: process.env.SINGLE_IDP_URL ?? '',
      USER_MANAGEMENT_URL: process.env.USER_MANAGEMENT_URL ?? '',
      VERSION: process.env.VERSION ?? '',
    };

export default config;
